import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Instance from "../../../Services/Instance";
import config from "../../../Services/config";
import { DataContext } from '../../../Services/DataContext';
import "../../../Assets/Styles/NetflixList.css"

const DeletePopup = ({ onClose, row }) => {
    const [loading, setLoading] = useState(false);
    const { refreshData } = useContext(DataContext);

    const handleDelete = async () => {
        try {
            setLoading(true);
            await Instance.delete(`${config.api_url}/delete-license/${row._id}`);
            toast.success("Licence supprimée avec succès !");
            onClose();
            refreshData()
        } catch (error) {
            toast.error("Erreur lors de la suppression !");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="netflix-popup-overlay">
            <div className="netflix-popup">
                <h2 className="netflix-popup-title">
                    Supprimer {row.productName} ?
                </h2>
                <p className="netflix-popup-text">Cette action est irréversible.</p>
                <div className="netflix-popup-buttons">
                    <button
                        onClick={onClose}
                        className="netflix-button netflix-button-cancel"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleDelete}
                        className={`netflix-button netflix-button-delete ${loading ? "netflix-button-disabled" : ""}`}
                        disabled={loading}
                    >
                        {loading ? "Suppression..." : "Supprimer"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeletePopup;
